<template>
  <transition name="fade">
    <div
      @click="selectedProduct"
      class="product-widget-main-container"
      :class="[
        editAble ? 'cursor-pointer' : '',
        isDisabledForCopy || isCopyBtnLoading || isCopyAllLinesToCartLoading
          ? 'disable'
          : '',
      ]"
    >
      <div
        class="product-widget-container"
        :class="[isProductWidgetSelcted ? 'editable' : '']"
      >
        <div class="d-flex ga-6">
          <div class="d-flex product-line-container">
            <div :class="[productClass]" class="d-flex align-center flex-wrap">
              <img
                v-if="line?.Part?.image"
                class="product-image"
                alt="product image"
                @error="handleImageError()"
                :src="line?.Part?.image"
              />
              <!-- {{line}} -->
              <!-- <div> -->
              <div
                class="info-container"
                v-if="line?.Part?.catalogId && line?.Part?.catalogId !== 'null'"
              >
                <p class="info-title">{{ $t("ProductWidget.SKU") }}</p>
                <p class="info-description">
                  {{ line.Part.catalogId }}
                </p>
              </div>
              <div class="info-container" v-if="line?.Part?.partname">
                <p class="info-title">{{ $t("ProductWidget.name") }}</p>
                <p class="info-description">
                  {{ line.Part?.partname }}
                </p>
              </div>
              <div class="info-container">
                <p class="info-title">
                  {{ $t("ProductWidget.quantity") }}
                </p>
                <p class="info-description">{{ line.quant }}</p>
              </div>
              <div class="info-container" v-if="line.discountPercent">
                <p class="info-title">
                  {{ "מחיר לפני הנחה" }}
                </p>
                <p class="info-description">
                  {{ "₪" + formatPrice(line?.Part?.price ?? 0) }}
                </p>
              </div>
              <div class="info-container" v-if="line.discountPercent">
                <p class="info-title">
                  {{ $t("ProductWidget.discount") }}
                </p>
                <p class="info-description">
                  {{ "%" + formatPrice(line.discountPercent) }}
                </p>
              </div>
              <div class="info-container">
                <p class="info-title">
                  {{ $t("ProductWidget.partPrice") }}
                </p>
                <p class="info-description">
                  {{ "₪" + formatPrice(line.partPrice) }}
                </p>
              </div>
              <div class="info-container moblie-info">
                <p class="info-title">
                  {{ $t("ProductWidget.finalPrice") }}
                </p>
                <p class="info-description">
                  {{ "₪" + formatPrice(line.totalPriceSum) }}
                </p>
              </div>
              <!-- </div> -->
              <!-- <div class="info-container" v-if="line.Part.Family.familyname">
                <p class="info-title">
                  {{ $t("ProductWidget.partFamily") }}
                </p>
                <p class="info-description">
                  {{ line.Part.Family.familyname }}
                </p>
              </div> -->
              <div class="info-container" v-if="orderNumber">
                <p class="info-title">
                  {{ $t("ProductWidget.orderNumber") }}
                </p>
                <p class="info-description">{{ orderNumber }}</p>
              </div>
              <div class="info-container" v-if="orderReference">
                <p class="info-title">
                  {{ $t("ProductWidget.reference") }}
                </p>
                <p class="info-description">{{ orderReference }}</p>
              </div>
              <!-- <div
                class="info-container"
                v-if="line.Part.partPrice || line.partPrice"
              >
                <p class="info-title">
                  {{ $t("ProductWidget.basePrice") }}
                </p>
                <p class="info-description">
                  {{ "₪" + formatPrice(line.Part.partPrice) }}
                </p>
              </div> -->
              <!-- <div
                class="info-container full-width"
                v-if="line.Part.partdes"
              >
                <p class="info-title">
                  {{ $t("ProductWidget.description") }}
                </p>
                <p class="info-description product-description">
                  {{ line.Part.partdes }}
                </p>
              </div> -->
            </div>
          </div>
        </div>
        <div v-if="editAble" class="checkbox-group">
          {{}}
          <div
            class="circle unchecked"
            :class="{
              disable:
                isDisabledForCopy ||
                isCopyBtnLoading ||
                isCopyAllLinesToCartLoading,
            }"
          >
            <div
              :class="[
                isProductWidgetSelcted
                  ? 'checked'
                  : isCopyBtnLoading || isCopyAllLinesToCartLoading
                  ? 'loading'
                  : '',
              ]"
            />
          </div>
        </div>
        <v-btn
          :loading="isCopyBtnLoading"
          class="copy-btn"
          :class="{ disable: isDisabledForCopy }"
          icon="mdi-content-copy"
          flat
          color="#F4EEE9"
          @click="copyLineToCart"
          v-if="mode === 'orders' && !editAble"
        >
        </v-btn>
        <!-- <v-fade-transition :leave-absolute="true" :hide-on-leave="true">
          <div v-if="editAble">
            <div
              class="d-flex align-end ga-5 mt-0 flex-wrap refund-btn-actions"
            >
              <div class="d-flex flex-column align-center">
                <span v-if="mode === 'invoices'" class="text-retrun-items"
                  >כמות פריטים להחזרה
                </span>
                <quantity-buttons
                  :TheTitle="quantButtonTitle"
                  :TheCounter="line.quant"
                  @updateCounter="updateCounter"
                  :disabled="isQuantityBtnDisable"
                />
              </div>
              <div class="d-flex flex-column align-center">
                <span
                  v-if="isShowErrorMessageRefundReason && mode === 'invoices'"
                  class="text-red-lighten-1"
                  >{{ $t("ProductWidget.refundReasonErrorMsg") }}</span
                >
                <input
                  v-if="mode === 'invoices'"
                  required
                  :placeholder="$t('SingelInvoice.refundReason')"
                  class="refund-reason-input"
                  v-model="refundReason"
                  @change="updateRefundReason"
                />
              </div>
            </div>
            <span v-if="false" class="text-red-lighten-1">{{
              $t("SingelInvoice.cantBeReturned")
            }}</span>
          </div>
          <div
            class="mt-5"
            v-if="line.refundRequest?.result && mode === 'invoices'"
          >
            <span class="refund-result" :class="[refundResultColor]">{{
              line.refundRequest.result
            }}</span>
          </div>
        </v-fade-transition> -->
      </div>
    </div>
  </transition>
</template>
<script>
// import QuantityButtons from "./QuantityButtons.vue";

export default {
  components: {},
  emits: [
    "copy",
    "favorit",
    "openModal",
    "delete",
    "updateCounter",
    "updateRefundReason",
    "addLineToCart",
    "removeLineFromCart",
    "copyLineToCart",
  ],
  props: {
    isCopyAllLinesToCartLoading: {
      type: Boolean,
    },
    isCopyBtnLoading: {
      type: Boolean,
    },
    isDisabledForCopy: {
      type: Boolean,
    },
    line: {
      type: Object,
    },
    doc: {
      type: Object,
    },
    isQuantityBtnDisable: {
      type: Boolean,
    },
    isForReturn: {
      type: Boolean,
      default: false,
    },
    orderNumber: null,
    orderReference: null,
    editAble: null,
    quantButtonTitle: null,
    mode: null,
  },
  data() {
    return {
      refundReason: "",
      quant: "",
      isShowErrorMessageRefundReason: true,
      isProductWidgetSelcted: false,
    };
  },
  watch: {
    isProductWidgetSelcted(val) {
      if (val) {
        this.addLineToCart();
      } else {
        this.$emit("removeLineFromCart", this.line);
      }
    },
    editAble(val) {
      if (!val) {
        this.isProductWidgetSelcted = false;
      }
    },
  },
  mounted() {
    if (this.line?.refundRequest?.refundReason) {
      this.refundReason = this.line.refundRequest.result;
    }
    if (this.line.quant) {
      this.quant = this.line.quant;
    }
    if (this.mode === "invoices") {
      this.updateCounter(this.line.quant);
    }
  },
  methods: {
    copyLineToCart() {
      this.$emit("copyLineToCart", this.line);
    },
    addLineToCart() {
      this.$emit("addLineToCart", this.line);
    },
    selectedProduct() {
      if (!this.editAble || this.isDisabledForCopy) return;
      this.isProductWidgetSelcted = !this.isProductWidgetSelcted;
    },
    formatPrice(price) {
      if (Number.isInteger(price)) {
        return price?.toString();
      } else {
        return price?.toFixed(2) ?? 0;
      }
    },
    handleImageError() {
      // evt.target.src = "@/assets/images/default-product-image.png";
    },
    updateCounter(quant) {
      let newQuant = quant;
      if (newQuant > this.line.quant && this.mode === "invoices") newQuant = 0;
      this.$emit("updateCounter", {
        ...this.line,
        quant: newQuant,
        refundReason: this.refundReason,
      });
      this.quant = newQuant;
    },
    updateRefundReason() {
      if (this.refundReason.trim().length > 0) {
        this.isShowErrorMessageRefundReason = false;
      } else this.isShowErrorMessageRefundReason = true;
      this.$emit("updateRefundReason", {
        ...this.line,
        refundReason: this.refundReason,
        quant: this.quant,
      });
    },
  },
  computed: {
    finalPriceCartLine() {
      const sum = this.line.Part.originPrice * this.line.quant;
      return sum;
    },
    refundResultColor() {
      if (this.line?.refundRequest?.isApproved) {
        return "approved";
      } else {
        return "unapproved";
      }
    },
    productClass() {
      if (this.orderReference && this.orderNumber) {
        if (this.$vuetify.display.mobile)
          return "invoices-product moblie-product";
        else return "invoices-product";
      }
      if (this.$vuetify.display.mobile) return "default-product moblie-product";
      else return "default-product";
    },
    calculatedMaxProductWidth() {
      if (this.orderReference && this.orderNumber) return "65%";
      return "100%";
    },
    // finalPrice() {
    //   if (this.line.Part.discount) {
    //     return Math.floor(
    //       this.line.Part.price -
    //         this.line.Part.price * (this.line.Part.discount / 100)
    //     ).toFixed(2);
    //   } else {
    //     return this.line.Part.price.toFixed(2);
    //   }
    // },
  },
};
</script>
<style lang="scss">
.copy-btn {
  .v-icon {
    color: $primaryColor;
  }
}
</style>

<style scoped lang="scss">
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.text-retrun-items {
  color: #36b079;
}
.refund-result {
  background: $primaryBackgroundColor;
  border-radius: 50px;
  padding: 8px;
  color: #36b079;
  width: max-content;
  font-size: $smallTextSize;
  font-weight: 400;
  line-height: 18.96px;
  text-align: right;
}

@media (max-width: 601px) {
  .refund-result {
    font-size: 15px;
  }
}

.refund-result.approved {
  color: #36b079;
}

.refund-result.unapproved {
  color: #d13257;
}

.refund-btn-actions {
  height: 50px;

  .wrapper {
    height: 100%;
  }
}
.refund-reason-input {
  max-width: 260px !important;
  border: 1px solid #fbecf0;
  padding: 5px 10px 5px 10px;
  box-shadow: 0px 0px 4px 0px #00000026 inset;
  border-radius: 15px;
  max-height: 40px !important;
  width: 100% !important;
  background: $primaryBackgroundColor;
}
.refund-reason-input::placeholder {
  color: #e1859b;
  font-size: $smallTextSize;
  font-weight: 400;
  line-height: 18.96px;
}

@media (max-width: 601px) {
  .refund-btn-actions {
    height: unset;
    margin-top: 0 !important;
  }

  .refund-reason-input {
    height: 50px !important;
  }
  .moblie-product {
    display: grid !important;
    grid-template-columns: 2fr 1fr;
    gap: 20px !important;
    .moblie-info {
      margin-top: 20px;
    }
    .full-width {
      grid-column: 1 / -1;
    }
  }
}

.invoices-product {
  gap: 35px;
  // margin-left: 10%;
}
.default-product {
  width: 100%;
  gap: 35px;
}
.info-container {
  // margin-left: 10px;
  // margin-right: 10px;
}
.product-image {
  border: 1px solid $tableOrderColor;
  border-radius: 8.16px;
  width: 102px;
  height: 102px;
  object-fit: contain;
}

.hide-on-med-and-down:first-child {
  .material-icons:hover {
    //     margin: 5px 0;
    //     position: relative;
    //     display: block;
    //     color: red;
    //     width: 0px;
    //     height: 0px;
    //     border-right: 10px solid transparent;
    //     border-bottom: 7px solid red;
    //     border-left: 10px solid transparent;
    //     transform: rotate(35deg);
  }
}

.product-widget-main-container {
  margin-bottom: 10px;
}

.product-widget-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  background-color: transparent;
  border-radius: 20px;
  border: 2px solid #ececec;
  padding: 20px;
  gap: 20px;

  .product-title-container {
    h2 {
      font-size: $mediumTextSize;
      font-weight: 600;
      word-wrap: break-word;
    }
    p {
      font-size: $extraSmallTextSize;
    }
  }

  .product-info2-container {
    display: grid !important;
    grid-template-columns: repeat(5, max-content);
  }

  .info-title {
    font-size: $mediumTextSize;
    font-weight: 700;
    line-height: 21.33px;
    text-align: right;
    overflow: unset;
  }
  .info-description {
    font-size: $mediumTextSize;
    color: $orderLineColor;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    overflow: unset;
  }
}

@media (max-width: 804px) {
  .product-widget-container {
    justify-content: center;
  }
}

.product-widget-container.editable {
  border: 2px solid $greenColor;
}

.product-line-container {
  gap: 20px;
}

@media (max-width: 601px) {
  .default-product {
    gap: 19px;
  }
  .product-image {
    width: 120px;
    height: auto;
  }
  .product-line-container {
    flex-direction: column;
  }
  .product-widget-container {
    margin-bottom: 25px;
    padding: 25px;

    div {
      justify-self: start;
    }
  }
}

.checkbox-group {
  .circle {
    width: 37px;
    height: 37px;
    border-radius: 50%;
  }

  .unchecked {
    box-shadow: inset 0 2px 7px #cacaca;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .checked {
    position: relative;
    width: 37px;
    height: 37px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $greenColor;
  }

  .checked::after {
    content: "✔";
    color: white;
    margin-top: 10%;
    font-size: 25px;
  }

  .loading {
    pointer-events: none;
    width: 37px;
    height: 37px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $tableOrderColor;
  }

  .loading::after {
    content: "";
    border: 2px solid white;
    border-top: 2px solid transparent;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
